import React from 'react';
import { Box, Container, Typography, Button, Paper } from '@mui/material';
import { Link, useParams } from 'react-router-dom';

const StorefrontPortalDisabledPage = () => {
  const { companyUrl } = useParams();

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          py: 8
        }}
      >
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h5" gutterBottom>
            Online booking unavailable
          </Typography>
          
          <Typography color="text.secondary" sx={{ mb: 4 }}>
            This business&apos;s online booking is not available right now. Please contact them directly to schedule.
          </Typography>

          {companyUrl ? (
            <Button variant="contained" component={Link} to={`/book/${companyUrl}`}>
              Back to site
            </Button>
          ) : (
            <Button variant="contained" href="/">
              Return home
            </Button>
          )}
        </Paper>
      </Box>
    </Container>
  );
};

export default StorefrontPortalDisabledPage;
